import React, { useState, useMemo, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useData } from '../../context/DataContext';
import ProductCard from '../../components/ProductCard/ProductCard';
import '../../styles/pages/Products.css';

const Products = () => {
  const { data, getProducts, getCategories, loading, error } = useData();
  const [searchParams] = useSearchParams();
  const categoryFromUrl = searchParams.get('category');
  const [activeCategory, setActiveCategory] = useState(categoryFromUrl || 'All');
  const backgroundImage = data?.images?.backgrounds?.products;

  // Update category when URL changes
  useEffect(() => {
    if (categoryFromUrl) {
      setActiveCategory(categoryFromUrl);
    } else {
      setActiveCategory('All');
    }
  }, [categoryFromUrl]);

  const products = getProducts();
  const categories = getCategories();

  const filteredProducts = useMemo(() => {
    if (activeCategory === 'All') return products;
    return products.filter(p => p.categoryIds && p.categoryIds.includes(activeCategory));
  }, [products, activeCategory]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading products...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <p>Error loading products: {error}</p>
      </div>
    );
  }

  const heroStyle = backgroundImage ? {
    '--page-hero-bg': `url(${backgroundImage})`
  } : {};

  return (
    <main className="products-page mandala-bg">
      <section className={`page-hero${backgroundImage ? ' has-bg-image' : ''}`} style={heroStyle}>
        <div className="container">
          <h1 className="page-title">{data?.products?.pageTitle || 'Our Products'}</h1>
          <p className="page-subtitle">{data?.products?.pageSubtitle || 'Fresh from the farm to your home'}</p>
        </div>
      </section>

      <section className="products-content">
        <div className="container">
          {/* Category Filter */}
          <div className="category-filter">
            <button
              className={`filter-btn ${activeCategory === 'All' ? 'active' : ''}`}
              onClick={() => setActiveCategory('All')}
            >
              All Products
            </button>
            {categories.map((category) => (
              <button
                key={category.id}
                className={`filter-btn ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </div>

          {/* Products Grid */}
          <div className="product-grid">
            {filteredProducts.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>

          {filteredProducts.length === 0 && (
            <div className="no-products">
              <p>No products found in this category.</p>
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Products;
